import { Flex, FormControl, FormLabel, Grid } from "@chakra-ui/react";
import { InputWithValidationControl } from "src/components/Inputs/InputWithValidationControl";
import { PhoneInput } from "src/components/Inputs/PhoneInput";
import useRequiredHasuraRoles from "src/hooks/useRequiredHasuraRoles";
import { HasuraRole } from "src/types/hasuraRole";
import { PASSWORD_MANAGER_IGNORE } from "src/types/passwordManager";
import { AddressForm } from "../../components/Forms/AddressForm";
import { NameForm } from "../../components/Forms/NameForm";

export const ParentDetailsForm: React.FC<{
  isDisabled?: boolean;
  // Opt in to required-field asterisks (used on the create page). Off by default.
  requiredIndicators?: boolean;
}> = ({ isDisabled = false, requiredIndicators = false }) => {
  const isAllowedToEditRefId = useRequiredHasuraRoles([
    HasuraRole.ADMIN,
    HasuraRole.ORG_ADMIN,
  ]);

  return (
    <Flex direction="column" gap={4}>
      <NameForm
        hide={["birth_date"]}
        firstName={{ label: "First name" }}
        middleName={{ label: "Middle name" }}
        lastName={{ label: "Last name" }}
        isDisabled={isDisabled}
        showRequiredIndicator={requiredIndicators}
      />
      <Grid gridTemplateColumns="repeat(auto-fit, minmax(15rem, 1fr))" gap={3}>
        <InputWithValidationControl
          isRequired={false}
          name="email_address"
          id="email_address"
          label="Email address (Optional)"
          inputProps={{
            placeholder: "E.g: dandoe@email.com",
            ...PASSWORD_MANAGER_IGNORE,
          }}
          isDisabled={isDisabled}
        />
        <FormControl>
          <FormLabel>Phone number (Optional)</FormLabel>
          <PhoneInput
            id="phone_number"
            name="phone_number"
            isRequired={false}
            inputProps={{
              placeholder: "E.g: +1 (555) 555-0100",
              ...PASSWORD_MANAGER_IGNORE,
            }}
          />
        </FormControl>
      </Grid>
      <InputWithValidationControl
        isRequired={false}
        name="reference_id"
        id="reference_id"
        label="Reference ID (Optional)"
        inputProps={{
          placeholder: "E.g.: 12345678",
          ...PASSWORD_MANAGER_IGNORE,
        }}
        isDisabled={!isAllowedToEditRefId || isDisabled}
      />
      <AddressForm isDisabled={isDisabled} isRequired={requiredIndicators} />
    </Flex>
  );
};
